import React from "react";
import { Link as RouterLink } from "react-router-dom";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";
import { createEditorialPlan } from "../editorial-analysis";
import { EditorialContent } from "../EditorialContent";
import { PostTitle } from "../PostTitle";

export function JournalPost({ post, onEdit }) {
  const plan = createEditorialPlan(post);
  const journalPlan = {
    ...plan,
    blocks: plan.blocks.map((block) =>
      block.type === "image" ? { ...block, role: "inline" } : block
    ),
  };

  return (
    <Box component="article" className="post post--journal" sx={{ py: { xs: 2, sm: 3 } }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1.5, flexWrap: "wrap" }}>
        {plan.isPrivate ? <Chip size="small" label="Privat" /> : null}
        {plan.visibility === "users" ? <Chip size="small" label="Brugere" color="info" variant="outlined" /> : null}
        {plan.dateLabel ? (
          <Typography variant="body2" color="text.secondary">
            {plan.dateLabel}
          </Typography>
        ) : null}
      </Box>
      <PostTitle title={plan.title} onEdit={onEdit} />
      {plan.author?.name ? (
        <Typography
          component={RouterLink}
          to={`/?author=${encodeURIComponent(plan.author.name)}`}
          variant="body2"
          color="text.secondary"
          sx={{ mb: 1, display: "inline-block", textDecoration: "none", "&:hover": { color: "primary.main" } }}
        >
          {plan.author.name}
        </Typography>
      ) : null}
      {plan.tags?.length ? (
        <Stack direction="row" spacing={0.75} useFlexGap flexWrap="wrap" sx={{ mb: 2 }}>
          {plan.tags.map((t) => (
            <Chip
              key={t}
              component={RouterLink}
              to={`/categories?tag=${encodeURIComponent(t)}`}
              clickable
              size="small"
              label={t}
              variant="outlined"
            />
          ))}
        </Stack>
      ) : null}

      <EditorialContent plan={journalPlan} />
    </Box>
  );
}
